/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".notes-container[_ngcontent-%COMP%]{width:45rem}.table-button[_ngcontent-%COMP%]{padding:15px;justify-content:center;display:flex}.table-button[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{width:20rem}.mat-table[_ngcontent-%COMP%]{width:100%;display:table}.table-container[_ngcontent-%COMP%]{padding:0 15px;max-height:600px;overflow:auto}.continue-container[_ngcontent-%COMP%]{padding:15px;background-color:#765937;justify-content:center;display:flex}.continue-container[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{width:20rem}"];
export { styles as styles };

